export default {
  errors: {
    'file-invalid-type': 'Le fichier n\'est pas autorisé',
    'file-too-large': 'Le fichier est trop volumineux',
    'too-many-files': 'Les fichiers sont trop nombreux',
  },
  okButton: 'Ok',
  typeAndSizeHint: 'Uniquement les fichiers {{type}} de {{size}} ou moins',
};
